import { useContext, useEffect, useState } from 'react';
import { ZakazkyContext } from '../services/zakazkyContext';

export const useZakazka = (id) => {
  const { zakazky } = useContext(ZakazkyContext);

  const [zakazka, setZakazka] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    if (zakazky) {
      // console.log(id);
      const foundZakazka = zakazky.find((zakazka) => {
        // console.log(zakazka.id === id);
        return Number(zakazka.id) === Number(id);
      });

      if (foundZakazka) {
        setLoading(false);
        setZakazka(foundZakazka);
      } else {
        setLoading(false);
        setError('Zakazka with this id doesnt exist');
      }
    } else {
      setLoading(false);
      setError('Zakazky is empty');
    }
  }, [zakazky, id]);

  return { zakazka, loading, error };
};
